import { useGetAllDevis } from "modules/devis/api";
import { Devis } from "modules/devis/types/devis.interface";
import { useCallback, useMemo, useState } from "react";
import DevisTable, { RowObjDevis } from "../default/components/devisTable";

const AllDevis = () => {
  const [filters, setFilters] = useState({
    dateRange: null,
    status: null,
    client: null,
  });
  const [searchName, setSearchName] = useState<string | undefined>(undefined);
  const {
    data,
    hasNextPage,
    fetchNextPage,
    fetchPreviousPage,
    isLoading,
  } = useGetAllDevis(searchName, 10, filters);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Memoize the current page data
  const flatData = useMemo(() => 
    data?.pages[currentPage - 1]?.data ?? [], 
    [data?.pages, currentPage]
  );

  // Memoize the formatted data
  const formattedData = useMemo((): RowObjDevis[] => {
    return flatData.map((item: Devis) => ({
      _id: item._id,
      workspaceId: item.workspaceId,
      clientId: item.clientId,
      createdAt: item.createdAt,
      totalHT: item.totalHT,
      totalTTC: item.totalTTC,
      dueDate: item.dueDate,
      updatedAt: item.updatedAt,
      status: item.status,
      archived: item.archived,
      lineItems: item.lineItems,
      documentNumber: item.documentNumber,
      client: item.client,
    }));
  }, [flatData]);

  const handleFetchNextPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
      setCurrentPage(prev => prev + 1);
    }
  }, [hasNextPage, fetchNextPage]);

  const handleFetchPrevPage = useCallback(() => {
    if (currentPage > 1) {
      fetchPreviousPage();
      setCurrentPage(prev => prev - 1);
    }
  }, [currentPage, fetchPreviousPage]);

  const totalPage = data?.pages[0]?.count ? Math.ceil(data.pages[0].count / 10) : 1;

  return (
    <DevisTable
      tableData={formattedData}
      searchName={searchName || ""}
      setSearchName={setSearchName}
      currentPage={currentPage}
      totalPage={totalPage}
      hasNextPage={hasNextPage}
      handleFetchNextPage={handleFetchNextPage}
      handleFetchPrevPage={handleFetchPrevPage}
      isLoading={isLoading}
      setFilters={setFilters}
      filters={filters}
    />
  );
};

export default AllDevis;
